export default __webpack_public_path__ + "static/video-bg-854ac239c39b6b0d0b9effc96f13434e.png";